// extracted by mini-css-extract-plugin
module.exports =  {"error-container":"_35875ce240--error-container--LGTUC","mobile":"_35875ce240--mobile--PmJaT"};